export default __webpack_public_path__ + "static/media/aysi.d6e98080.jpeg";